export const HOME = {
    emergentLink: "home-emergent-link",
};

export const DASHBOARD = {
    root: "dashboard-root",
    nav: "dashboard-nav",
    hero: "dashboard-hero",
    heroEarthScore: "hero-earth-score",
    heroBatteryHealth: "hero-battery-health",
    heroTrees: "hero-trees",
    heroOcean: "hero-ocean",
    heroCo2: "hero-co2",
    heroBatteryLife: "hero-battery-life",
    milestones: "milestones-section",
    milestone: (id) => `milestone-${id}`,
    community: "community-tracker",
    communityMetric: (key) => `community-metric-${key}`,
    allocation: "impact-allocation",
    causes: "cause-selection",
    causeCard: (id) => `cause-select-${id}`,
    veteran: "veteran-initiative",
    pricing: "pricing-plans",
    plan: (id) => `pricing-plan-${id}`,
    battery: "battery-impact",
    annualReport: "annual-report-preview",
    sponsors: "corporate-sponsors",
    sponsorCard: (slug) => `sponsor-card-${slug}`,
    navLink: (id) => `nav-link-${id}`,
    marketingLink: "nav-marketing-link",
};

export const PAGES = {
    battery: "page-battery",
    community: "page-community",
    report: "page-report",
    partners: "page-partners",
    blogPost: (slug) => `blog-post-${slug}`,
    blogPostTitle: "blog-post-title",
};
